module.exports = __webpack_public_path__ + "img/4.d89d5db7.png";